<app-folder-service-mail-records class="subpage-content"></app-folder-service-mail-records>

<div #dialogFooter></div>
